// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../../../auth/fragments/customerRegistrationResponse.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartJewelleryNewCustomerDocument = gql`
    mutation addToCartJewelleryNewCustomer($input: DesignStudioJewelleryInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createDesignStudioProductAndAddToCartJewelleryNewCustomer(
    input: $input
    customer: $customer
  ) {
    __typename
    ... on CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer {
      customer {
        ...customerRegistrationResponse
      }
    }
  }
}
    ${CustomerRegistrationResponseFragmentDoc}`;

export function useAddToCartJewelleryNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartJewelleryNewCustomerMutation, SchemaTypes.AddToCartJewelleryNewCustomerMutationVariables>(AddToCartJewelleryNewCustomerDocument);
};